var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('p',[_vm._v("There is nothing to see here")]),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"link":""},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("Go Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }